import PricingPage from '../en/pricing';
export default PricingPage;